import React, { useEffect, useState } from 'react';
import { TChainName, TComputeStepParams } from '../types';
import { Contract } from 'ethers';
import { getAggregatorContract } from '../utils';

export function useEncodeOperations (
    chainName: TChainName,
    operations: TComputeStepParams[]
): {encodedOperations: string, errorOps: string, encodeOps: () => void} {

    const [encodedOperations, setEcodedOperations] = useState<string>('');
    const [errorOps, setErrorOps] = useState<string>('');

    const encodeOps = () => {

        (async () => {

            const aggregator: Contract = getAggregatorContract(chainName);

            const encoded: string = await aggregator.encodeOptions(operations);

            if(encoded){
                setEcodedOperations(encoded);
                setErrorOps('');
            }

        })().catch((e: {message:string}) => {
            setErrorOps(e.message);
            console.error("useEncodeOperations", e)
        })

    }

    useEffect(() => {

        

    }, [operations])

    return {encodedOperations, errorOps, encodeOps};

}